import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/news";
import SubscribeForm from "@/components/feature/SubscribeForm";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="border-b border-primary-800">
        <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-8 px-4 py-12 md:px-6 lg:grid-cols-2 lg:gap-16">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-base font-bold text-primary-700">
                51
              </span>
              <div>
                <p className="font-serif-cn text-xl font-bold text-background-50">{siteInfo.name}</p>
                <p className="text-xs tracking-widest text-accent-300">{siteInfo.slogan}</p>
              </div>
            </div>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-300">
              {siteInfo.intro}
            </p>
          </div>

          <div>
            <p className="font-serif-cn text-lg font-semibold text-background-50">
              订阅今日速递
            </p>
            <p className="mt-2 text-sm text-background-300">
              每天早晚各一封，把当天最值得留意的爆料与快讯送到你手上。
            </p>
            <div className="mt-4">
              <SubscribeForm />
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-6">
        <div className="grid grid-cols-2 gap-8 lg:grid-cols-4">
          <div>
            <h4 className="mb-4 font-serif-cn text-sm font-semibold uppercase tracking-wider text-accent-300">
              <Link to="/" className="hover:text-background-50">
                网站首页
              </Link>
            </h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li>
                <Link to="/" className="transition hover:text-accent-300">
                  今日头版
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition hover:text-accent-300">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-serif-cn text-sm font-semibold uppercase tracking-wider text-accent-300">
              热门栏目
            </h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              {categories.slice(0, 4).map((item) => (
                <li key={item.slug}>
                  <Link to={`/category/${item.slug}`} className="transition hover:text-accent-300">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-serif-cn text-sm font-semibold uppercase tracking-wider text-accent-300">
              更多栏目
            </h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              {categories.slice(4).map((item) => (
                <li key={item.slug}>
                  <Link to={`/category/${item.slug}`} className="transition hover:text-accent-300">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-serif-cn text-sm font-semibold uppercase tracking-wider text-accent-300">
              联系我们
            </h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-accent-400" />
                <a href={`mailto:${siteInfo.email}`} className="transition hover:text-accent-300">
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-fill text-base text-accent-400" />
                <span>{siteInfo.weibo}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-base text-accent-400" />
                <span>每日 07:00 - 23:30 更新</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-2 px-4 py-5 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© 2026 {siteInfo.name} 保留所有权利</p>
          <p className="text-background-400">
            站内内容为信息聚合，具体进展请以相关方面正式发布为准。
          </p>
        </div>
      </div>
    </footer>
  );
}